import React, { ReactNode } from 'react'
import Head from 'next/head'
import styled from 'styled-components'
import { Button } from '@geist-ui/react'
import Content from './Content'

const Container = styled.div`
  background-color: #101010;
`

const ErrorContainer = styled.div`
  margin-top: 75px;
  background-color: #101010;
  min-height: calc(100vh - 150px);
  color: white;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledButton = styled(Button)`
  width: 200px;
  height: 40px;
  border-radius: 10px;
  border-width: 0;
  margin: 20px 0 0 0 !important;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;
`

const ButtonLabel = styled.span`
  font-weight: 700;
  font-size: 18px;
  text-transform: none;
`

type Props = {
  children?: ReactNode
  title?: string
  description?: string
  image?: string
  url?: string
  preview?: string
  error?:
    | {
        title: string
        description: string
        content: string
        action?: {
          title: string
          handler: (update?: unknown) => void
        }
      }
    | undefined
  isProtected?: boolean
}

const Layout = ({
  children,
  title = 'Glass',
  description = 'Video, owned by you.',
  image = 'https://glassimg.imgix.net/social.jpg?w=600&h=300',
  url = 'https://glass.xyz',
  preview,
  error,
}: Props): JSX.Element => {
  const content = error ? (
    <ErrorContainer>
      {error.content}
      {error.action && (
        <StyledButton type="secondary-light" onClick={error.action.handler}>
          <ButtonLabel>{error.action.title}</ButtonLabel>
        </StyledButton>
      )}
    </ErrorContainer>
  ) : (
    children
  )

  return (
    <Container>
      <Head>
        <title>{title}</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:url" content={url} />
        {/* USE MP4 VIDEO / TRAILER IN META TAGS */}
        {preview && <meta property="og:video" content={preview} />}
        <meta property="og:site_name" content="Glass" />
        <meta name="twitter:image:alt" content={title} />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      <Content>{content}</Content>
    </Container>
  )
}

export default Layout
